export const host = "https://musobeks-realtime-messenger.herokuapp.com";
export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/login`;
export const setAvatarRoute = `${host}/api/auth/set-avatar`;
export const allUsersRoute = `${host}/api/auth/all-users`;
export const sendMessageRoute = `${host}/api/messages/add-message`;
export const getAllMessagesRoute = `${host}/api/messages/get-all-messages`;